import { createHash } from "crypto";
import { Color } from "three";

const parseHex = (text, min, max) => {
  return parseInt(text.slice(min, max), 16);
};

export const textToColor = (text, opacity=1.0) => {
  let [r,g,b,a] = textToColorArray(text, opacity);
  return `rgba(${Math.ceil(r)}, ${Math.ceil(g)}, ${Math.ceil(b)}, ${a})`;
};

export const textToColorArray = (text, opacity=1.0) => {
  const colorHash = createHash('md5');
  const hash = colorHash.update(text).digest('hex');
  const h = (parseHex(hash, 0, 8) + parseHex(hash, 8, 16)) % 360;
  const s = 50 + (parseHex(hash, 16, 24) % 50);
  const l = 25 + (parseHex(hash, 24, 32) % 50);

  const color = new Color(`hsl(${h}, ${s}%, ${l}%)`);
  const {r,g,b} = color.multiplyScalar(255);

  return [Math.ceil(r), Math.ceil(g), Math.ceil(b), opacity];
};
